import { checkIsBirdviewNormalState } from '../DashboardBirdview.utils'

export function checkHasDashboardTileDelta({ delta, state }) {
  return Boolean(delta) && checkIsBirdviewNormalState(state)
}
